module.exports = __webpack_public_path__ + "img/axchart_word_white_logo.3e083bf6.png";